import type { RefCallback, RefObject } from 'react';
import { useAuth } from '../../stores/AuthContext';
import Avatar from '../ui/Avatar';
import SideNavMobile from '../sidenav/SideNavMobile';

interface DashboardHeaderProps {
  searchSlotRef: RefCallback<HTMLDivElement>;
  navigationTargetRef?: RefObject<HTMLButtonElement | null>;
}

const DashboardHeader = ({
  searchSlotRef,
  navigationTargetRef,
}: DashboardHeaderProps) => {
  const { user } = useAuth();

  return (
    <header
      data-dashboard-header
      className="grid shrink-0 grid-cols-[minmax(0,1fr)_auto] items-center gap-x-4 gap-y-2 border-b border-[var(--light-gray)] bg-base-200 px-3 py-2 md:px-6 md:py-5"
    >
      <div className="col-start-1 row-start-1 md:hidden">
        <SideNavMobile navigationTargetRef={navigationTargetRef} />
      </div>
      <div
        ref={searchSlotRef}
        data-header-search
        className="col-span-2 row-start-2 w-full min-w-0 empty:hidden md:col-span-1 md:col-start-1 md:row-start-1 md:max-w-[640px] [&_.fieldset]:py-0"
      />
      <div className="col-start-2 row-start-1 flex justify-end">
        {user && (
          <Avatar
            initials={`${user.firstName?.charAt(0) ?? ''}${user.lastName?.charAt(0) ?? ''}`.toUpperCase()}
            src={user.avatarUrl ?? null}
          />
        )}
      </div>
    </header>
  );
};

export default DashboardHeader;
